import _ from 'lodash';
import { useSelector } from 'react-redux';
import { ReducerKeys } from '..';
// import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { StateStatus } from '../../utils/common';

interface ICountry {
  country_id: number;
  code: string;
  description: string;
  numeric_code: number;
}

export const useGetMemberStateCountries = (): Array<ICountry> => {
  const data = useSelector((state: any) =>
    _.get(state[ReducerKeys.REQUEST_REDUCER], 'memberStateList.data', [])
  );
  return data;
};

export const useGetAllCountries = (): Array<ICountry> => {
  const data = useSelector((state: any) =>
    _.get(state[ReducerKeys.REQUEST_REDUCER], 'countriesList.data', [])
  );
  return data;
};

export const useGetRegistrationRequestStatus = (): StateStatus | null => {
  const status = useSelector((state: any) =>
    _.get(state[ReducerKeys.REQUEST_REDUCER], 'registrationRequest', null)
  );
  return status;
};

export const useGetVatReturnRequestStatus = (): StateStatus | null => {
  const status = useSelector((state: any) =>
    _.get(state[ReducerKeys.REQUEST_REDUCER], 'vatReturnRequest', null)
  );
  return status;
};

export const useGetMemberStateExcludeCyprusCountries = (): Array<ICountry> => {
  const data = useSelector((state: any) =>
    _.get(
      state[ReducerKeys.REQUEST_REDUCER],
      'memberStateExcludeCyprusList.data',
      []
    )
  );
  return data;
};
